import React from 'react';

interface QuestionBooleanIconProps {
  size?: number;
}

const QuestionBooleanIcon: React.FC<QuestionBooleanIconProps> = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5455 1.5H7.45455C4.99437 1.5 3 3.51472 3 6C3 8.48528 4.99437 10.5 7.45455 10.5H16.5455C19.0056 10.5 21 8.48528 21 6C21 3.51472 19.0056 1.5 16.5455 1.5Z" stroke="#0B66C2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 7.5C8.32843 7.5 9 6.82843 9 6C9 5.17157 8.32843 4.5 7.5 4.5C6.67157 4.5 6 5.17157 6 6C6 6.82843 6.67157 7.5 7.5 7.5Z" stroke="#0B66C2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.45455 22.5L16.5455 22.5C19.0056 22.5 21 20.4853 21 18C21 15.5147 19.0056 13.5 16.5455 13.5L7.45455 13.5C4.99437 13.5 3 15.5147 3 18C3 20.4853 4.99437 22.5 7.45455 22.5Z" stroke="#0B66C2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.5 16.5C15.6716 16.5 15 17.1716 15 18C15 18.8284 15.6716 19.5 16.5 19.5C17.3284 19.5 18 18.8284 18 18C18 17.1716 17.3284 16.5 16.5 16.5Z" stroke="#0B66C2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default QuestionBooleanIcon;
